<!--
 * @Description: 
-->
<template>
	<div class="page-foot">
		<div class="caintair">
			<div class="block">
				<div class="title">关于极智数科</div>
				<div class="items">
					<div class="item" @click="handleClickAbout">公司简介</div>
					<div class="item" @click="handleClickAbout">发展历程</div>
				</div>
			</div>
            <div class="block">
				<div class="title">产品</div>
				<div class="items"> 
					<div class="item nowrap" style="width:140px;" v-for="(item,index) in productArr" :key="index" @click="productDetail(item)">{{ item.productName }}</div>                    
				</div>
			</div>
            <div class="block">
				<div class="title">解决方案</div>
				<div class="items">
					<div class="item nowrap"  style="width:140px;" v-for="(item,index) in planArr" :key="index" @click="handleClickPlan(item)">{{ item.schemeName }}</div>
				</div>
			</div>
            <div class="block">
				<div class="title">案例展示</div>
				<div class="items">
					<div class="item nowrap" style="width:140px;" v-for="(item,index) in casesArr" :key="index" @click="handleClickCase(item)">{{ item.title }}</div>
				</div>
			</div>
            <div class="block">
				<div class="title">服务热线</div>
			    <div class="phone">0755-86952970</div>
                <a href="http://personal.jizhishuke.com/productFeedBack" target="_blank"><img class="product_back" src="../assets/images/product-back.png" alt=""></a>
			</div>
            <div class="block flex tflex">
                <div class="img" style="margin-right: 40px;"><img class="code-img" src="../assets/images/ercode01.png" alt=""><div class="name">极智数科公众号</div></div>
                <div class="img"><img class="code-img" src="../assets/images/ercode02.png" alt=""><div class="name">极智BIM软件技术服务群</div></div>
            </div>
		</div>
        <div class="tips">Copyright @ 2021-2026 深圳市极智数字科技有限公司 All rights reserved. <a data-v-3ca43d5d="" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">粤ICP备2021053912号-3</a></div>
	</div>
</template>
<script>
export default {
	data() {
		return {
            productArr:[],
            planArr:[],
            casesArr:[],
        };
	},
	created() {
        this.getProduct()
        this.getPlanListData()
        this.getCasesListData()
    },
	mounted() {},
    methods:{
        getPlanListData() {
			this._get(this.API.planList+'?pageNo=1&pageSize=100').then(res => {
				if(res.code == 200) {
					this.planArr = res.data.records
				}
			})
		},
        getCasesListData() {
			this._get(this.API.caseList+'?pageNo=1&pageSize=100').then(res => {
				if(res.code == 200) {
					this.casesArr = res.data.records
				}
			})
		},
        // 产品列表
        getProduct(){
			this._get(this.API.productList+'?pageNo=1&pageSize=100').then(res=>{
				// console.log('产品列表=====',res)
				if(res.code==200){
					this.productArr = res.data.records
				}
			})
		},
        productDetail(item){
            sessionStorage.removeItem('currentPlan')
			sessionStorage.setItem('currentProduct',item.id)
			this.$router.push({ name: 'empty', query: { path:'product',id:item.id } });
        },

        handleClickPlan(item) {
			this.$router.push({ name: 'empty', query: { path:'plan',id:item.id } });

        },
        handleClickCase(item) {
            window.open(item.link)

        },

        handleClickAbout() {
			this.$router.push({ name: 'empty', query: { path:'about'} });
        }
    },
};
</script>
<style lang="less" scoped>
.page-foot {
	height: auto;
	background-color: #02182f;
	.caintair {
		width: 1200px;
		margin: 0 auto;
        padding-top: 60px;
		display: flex;
        justify-content: space-between;
        .block {
            .title {
                color: #fff;
                font-weight: 700;
                font-size: 16px;
            }
            .phone {
                font-size: 24px;
                font-weight: 500;
                color: #fff;
                margin-top: 30px;
            }
            .product_back {
                margin-top: 30px;
                cursor: pointer;
            }
            .img {
                display: flex;
                flex-direction: column;
                align-items: center;
                .code-img {
                    width: 150px;
                    height: 150px;
                    display: block;
                }
                .name {
                    margin-top: 20px;
                    color: #fff;
                    font-size: 14px;
                }
            }
            .items {
                margin-top: 30px;
                .item {
                    font-size: 12px;
                    color: #ACB1BB;
                    margin-bottom: 20px;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }

                }
            }

        }
	}

    .tips {
        width: 1200px;
		margin: 0 auto;
        color: #828C95;
        font-size: 12px;
        margin-top: 62px;
        padding-bottom: 24px;
        text-align: center;
    }
}
.nowrap{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>
